import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "ServerButton";

const classes = {
  toolbarActionButton: `${PREFIX}-toolbarActionButton`,
};

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: "bold",
  marginBottom: 0,
  marginLeft: theme.shape.padding,
  marginRight: theme.shape.padding,
  marginTop: 5,
  padding: "9px 18px",
  textTransform: "none",
  "&.Mui-disabled": {
    color: theme.palette.action.disabled,
  },
  [`.${classes.alignRightAction}`]: {
    position: "absolute",
    right: 0,
  },
}));

const ServerButton = ({
  alignRight,
  children,
  datacy,
  disabled,
  icon: Icon,
  onClick,
  tooltip,
  variant,
}) => {
  return (
    <StyledButton
      key={tooltip}
      onClick={onClick}
      datacy={datacy ? datacy : "simpleTableToolbarBtn"}
      className={alignRight && classes.alignRightAction}
      startIcon={Icon && <Icon />}
      disabled={disabled ? disabled : false}
      variant={variant || "text"}
    >
      {children}
    </StyledButton>
  );
};

ServerButton.propTypes = {
  alignRight: PropTypes.bool,
  children: PropTypes.node.isRequired,
  datacy: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.elementType,
  onClick: PropTypes.func,
  tooltip: PropTypes.string.isRequired,
  variant: PropTypes.string,
};

export default ServerButton;
